
import React from 'react'
import { Select, SelectProps } from 'antd';

export const SortType = {
  desc: 'order_num-', // 从大到小
  asce: 'order_num+', // 从小到大
} 

export const SortTypeMap = {
  [SortType.desc]: '从大到小',
  // Ai Start
  [SortType.asce]: '从小到大',
  // Ai End
}

export interface FilterSortProps extends SelectProps {}


export const FilterSort = (props: FilterSortProps) => {
  const { placeholder = '排序值排序', mode, ...reset } = props;
  const options = Object.entries(SortTypeMap).map(([value, label]) => ({ label, value }))
  
  return (
    <Select
      style={{ width: '100%' }}
      mode={mode}
      options={[{ label: "默认", value: '' }, ...options]}
      placeholder={placeholder}
      {...reset}
    />
  )
}